const TYPE = {
    ID_CONTACT_APP: 2,
    ID_EMPLOYEE_EMPLOYER: 3,
    ID_CLIENT_VENDOR: 4,
    ID_OWNER_OWNEDBY: 6,
    ID_CLINIC_PATIENT: 11,
    ID_CLINIC_APP: 13,
    ID_CONTACT_CLINIC: 14,
    ID_CLIENT_RELATION: 30
};

const PATIENT_ACTOR = {
    OWNER: 7,
    REFERRING_DVM: 8,
    GROOMED_BY: 9,
    BOARDED_AT: 10,
    CLINIC: 11,
    FACILITY: 12,
    PHARMACIST_FOR: 15,
    FOSTERED_BY: 24,
    ADOPTED_BY: 25,
    EMERGENCY_CONTACT: 26,
    PREVIOUS_OWNER: 29
};

const BUSINESS_ACTOR = {
    EMPLOYEE: "3",
    CLIENT: "4",
    OWNER: "6",
    CONTACT: "14",
    CARETAKER: "17"
};

export default {
    TYPE,
    PATIENT_ACTOR,
    BUSINESS_ACTOR
};
